// src/pages/users/UserManagementPage.jsx
import React, { useState } from 'react';
import PaginationZeroBased from '@components/common/PaginationZeroBased';

function UserManagementPage() {
  // 더미 사용자 데이터
  const [users] = useState([
    { id: 1, username: 'user1', name: '홍길동', email: 'user1@example.com', role: '관리자', status: '활성' },
    { id: 2, username: 'user2', name: '김철수', email: 'user2@example.com', role: '일반', status: '활성' },
    { id: 3, username: 'user3', name: '이영희', email: 'user3@example.com', role: '일반', status: '비활성' },
    { id: 4, username: 'user4', name: '박지민', email: 'user4@example.com', role: '일반', status: '활성' },
    { id: 5, username: 'user5', name: '최유리', email: 'user5@example.com', role: '관리자', status: '활성' },
  ]);
  
  // 페이지네이션 상태 관리
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [hasNext, setHasNext] = useState(false);
  const [hasPrevious, setHasPrevious] = useState(false);
  
  // 페이지 변경 핸들러
  const handlePageChange = (newPage) => {
    setPage(newPage);
    // 실제 구현에서는 여기서 API 호출하여 새 페이지 데이터를 가져옴
  };

  return (
    <div className="user-management-page">
      <div className="page-header">
        <h1>사용자 관리</h1>
        <button className="add-button">사용자 추가</button>
      </div>

      <div className="search-bar">
        <input type="text" placeholder="사용자 검색..." />
        <button className="search-button">검색</button>
      </div>

      <div className="user-table-container">
        <table className="user-table">
          <thead>
          <tr>
            <th>ID</th>
            <th>사용자명</th>
            <th>이름</th>
            <th>이메일</th>
            <th>역할</th>
            <th>상태</th>
            <th>작업</th>
          </tr>
          </thead>
          <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.username}</td>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{user.role}</td>
              <td>
                <span className={`status-badge ${user.status === '활성' ? 'active' : 'inactive'}`}>
                  {user.status}
                </span>
              </td>
              <td className="action-buttons">
                <button className="edit-button">수정</button>
                <button className="delete-button">삭제</button>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>

      <PaginationZeroBased
        page={page}
        totalPages={totalPages}
        hasNext={hasNext}
        hasPrevious={hasPrevious}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default UserManagementPage;